'use strict';

var AbstractWizardView = require('components/common/views/abstract_wizard_view');
var OOP = require('utils/oop');
var I18N = require('utils/i18n');
var Misc = require('utils/misc');
var Validation = require('utils/validation');

module.exports = OOP.extend(
    AbstractWizardView,
    {
        template: require('components/profile/templates/api_token_dialog'),

        ui: {
            inputName: '#name-input',
            inputExpiration: '#expiration-input',
            inputSourceIP: '#source_ip-input',
            inputMonthlyLimit: '#monthly_limit-input',
            inputHourlyLimit: '#hourly_limit-input',
            cbModbusAccess: '#cb-modbus-access',
            removeExpiration: '#js-remove-expiration',
        },

        noExpiration: I18N.TR('nicht gesetzt'),

        getWizardEvents: function () {
            return {
                'mousedown @ui.inputExpiration': 'initDatePicker',
                'keydown @ui.inputExpiration': function (e) {
                    e.preventDefault();
                    return false;
                },
                'click @ui.removeExpiration': function () {
                    this.model.set('expiration', '0001-01-01');
                    this.ui.inputExpiration.val('');
                    this.ui.removeExpiration.addClass('disabled');
                },
            };
        },

        initialize: function (options) {
            this.base.initialize(options);

            this.model = options.model;

            var expiration = this.model.get('expiration') || '0001-01-01';

            this.model.set('groups', this.model.get('groups') || []);
            this.model.set('name', this.model.get('name') || '');
            this.model.set('expiration', expiration.substring(0, 10));
            this.model.set('source_ip', this.model.get('source_ip') || '');
            this.model.set('monthly_limit', this.model.get('monthly_limit') || 450000);
            this.model.set('hourly_limit', this.model.get('hourly_limit') || 600);
            this.model.set('modbus_access', this.model.get('modbus_access') || false);
        },

        save: function () {
            // get current input (depend on wizard page)
            var input = Backbone.Syphon.serialize(this);
            if (!input) {
                return;
            }

            if (input.groups === null) {
                input.groups = [];
            }
            if (input.groups != undefined) {
                this.model.set('groups', input.groups);
            }

            if (this.selected !== 2) {
                return;
            }

            // model update
            var name = $(this.ui.inputName).val();
            if (name != undefined) {
                this.model.set('name', name);
            }

            var expiration = $(this.ui.inputExpiration).val();
            if (expiration != undefined) {
                if (expiration === this.noExpiration) {
                    expiration = '0001-01-01';
                }
                this.model.set('expiration', expiration);
            }

            var sourceIP = $(this.ui.inputSourceIP).val();
            if (sourceIP != undefined) {
                this.model.set('source_ip', sourceIP.trim());
            }

            var monthlyLimit = $(this.ui.inputMonthlyLimit).val();
            if (monthlyLimit != undefined) {
                this.model.set('monthly_limit', parseInt(monthlyLimit));
            }

            var hourlyLimit = $(this.ui.inputHourlyLimit).val();
            if (hourlyLimit != undefined) {
                this.model.set('hourly_limit', parseInt(hourlyLimit));
            }

            if ($(this.ui.cbModbusAccess)[0]) {
                this.model.set('modbus_access', $(this.ui.cbModbusAccess)[0].checked);
            }
        },

        isValid: function () {
            this.save();
            return this.model.attributes.name != '';
        },

        canWizardFinish: function () {
            return this.base.canWizardFinish() && (this.isValid() || this.selected == 2);
        },

        wizardDone: function () {
            this.save();

            var isValid = Validation.validate(
                this,
                function (frm) {
                    this.required(
                        'name',
                        frm.model.get('name'),
                        I18N.TR('Der Name muss angegeben werden.'),
                        frm.ui.inputName
                    );
                    this.maxLen(
                        'name',
                        frm.model.get('name'),
                        100,
                        I18N.TR('Der Name darf nicht länger als 100 Zeichen sein.'),
                        frm.ui.inputName
                    );
                    this.custom(
                        'source_ip',
                        function () {
                            var IPFormat = RegExp('\\d{1,3}[.]\\d{1,3}[.]\\d{1,3}[.]\\d{1,3}[/]\\d{1,2}');
                            var sourceIP = frm.model.get('source_ip');
                            var isOK = sourceIP.search(IPFormat) != -1;
                            return isOK || sourceIP == '' ? '' : I18N.TR('Ungültiges CIDR Format.');
                        },
                        undefined
                    );
                    this.custom(
                        'expiration',
                        function () {
                            var DateFormat = RegExp('(2\\d{3})-(0[1-9]|1[0-2])-(0[1-9]|[12]\\d|3[01])');
                            var expiration = frm.model.get('expiration');
                            var isOK = expiration.search(DateFormat) != -1;
                            return isOK || expiration == '' || expiration == '0001-01-01'
                                ? ''
                                : I18N.TR('Ungültiges Datumsformat.');
                        },
                        undefined
                    );
                    this.custom(
                        'monthly_limit',
                        function () {
                            var errors = Validation.validateNumber(frm.model.get('monthly_limit'), 0, 450000);
                            return errors.length ? I18N.TR('Ungültiger Wert - Maximum 450000.') : '';
                        },
                        undefined
                    );
                    this.custom(
                        'hourly_limit',
                        function () {
                            var errors = Validation.validateNumber(frm.model.get('hourly_limit'), 0, 600);
                            return errors.length ? I18N.TR('Ungültiger Wert - Maximum 600.') : '';
                        },
                        undefined
                    );
                },
                undefined,
                true
            );

            if (isValid) {
                var self = this;

                // post process expiration time stamp
                if (this.model.get('expiration').trim() === '') {
                    this.model.set('expiration', '0001-01-01');
                }
                // .. append time-suffix to comply with the go time-format
                this.model.attributes.expiration += 'T00:00:00Z';

                this.options.cb(this.model, function (errors) {
                    self.errors = errors;
                    self.render();
                });
            }
        },

        doWizardNext: function () {
            this.save();
            this.base.doWizardNext();
        },

        getTabNames: OOP.inheritedObj('getTabNames', {
            Devices: I18N.TR('Gerätegruppen'),
            Token: I18N.TR('Token'),
        }),

        onShow: function () {
            this.base.onShow();
            this.initControls();
        },

        onRender: function () {
            this.initControls();
        },

        initControls: function () {
            Misc.initializeMultiSelect('#group_multi_select', I18N.TR('Verfügbar'), I18N.TR('Freigegeben'));

            this.ui.removeExpiration.removeClass('disabled');
            if (this.model.get('expiration').substring(0, 10) === '0001-01-01') {
                this.ui.removeExpiration.addClass('disabled');
            }
        },

        initDatePicker: function () {
            Misc.initDatePicker({
                timePicker: false,
                singleDatePicker: true,
                minDate: moment().add(1, 'days'),
                startDate: this.model.get('expiration').substring(0, 10) || moment().format('yyyy-mm-dd'),
                format: 'yyyy-mm-dd',
                closest: 'input',
            });
            this.ui.removeExpiration.removeClass('disabled');
        },

        serializeData: function () {
            var data = this.base.serializeData();

            data.wizardContext = this.getWizardContext();
            data.groups = this.options.groups;

            data.formData = {
                groups: this.model.get('groups'),
                name: this.model.get('name'),
                expiration: this.model.get('expiration'),
                source_ip: this.model.get('source_ip'),
                modbus_access: this.model.get('modbus_access'),
                hourly_limit: this.model.get('hourly_limit'),
                monthly_limit: this.model.get('monthly_limit'),
            };
            data.errors = this.errors;

            data.isNewToken = this.options.newToken;
            data.noExpirationText = this.noExpiration;

            return data;
        },
    },
    'ApiTokenDialogView'
);
